<div class="general-info-card">
    <div class="header-row">
        <h3>General Information</h3>
    </div>

    <div class="info-list">
        <div class="info-row" *ngIf="placement?.flockNo || flockNo">
            <div class="label">Cycle Name</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.flockNo || flockNo }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Supplier</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.suppierName || supplier || '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Farm</div>
            <div class="sep">:</div>
            <div class="value">
                {{ placement?.farmName || farmName || '-' }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">House</div>
            <div class="sep">:</div>
            <div class="value">
                <ng-container
                    *ngIf="
                        placement?.placementHousePartition?.length;
                        else housesFallback
                    "
                >
                    <ng-container
                        *ngFor="
                            let hp of placement.placementHousePartition;
                            let last = last
                        "
                    >
                        {{ hp.farmhouseName }}<span *ngIf="!last">, </span>
                    </ng-container>
                </ng-container>
                <ng-template #housesFallback>
                    {{ join(houses) || '-' }}
                </ng-template>
            </div>
        </div>
        <div class="info-row">
            <div class="label">Partitions</div>
            <div class="sep">:</div>
            <div class="value">
                <ng-container
                    *ngIf="
                        placement?.placementHousePartition?.length;
                        else partitionsFallback
                    "
                >
                    <ng-container
                        *ngFor="
                            let hp of placement.placementHousePartition;
                            let last = last
                        "
                    >
                        {{ hp.partitionName }}<span *ngIf="!last">, </span>
                    </ng-container>
                </ng-container>
                <ng-template #partitionsFallback>
                    {{ join(partitions) || '-' }}
                </ng-template>
            </div>
        </div>
        <div class="info-row">
            <div class="label">Placement Date &amp; Time</div>
            <div class="sep">:</div>
            <div class="value">
                {{
                    placement?.placementDateTime || placementDateTime
                        | date: 'yyyy-MM-dd'
                }}
            </div>
        </div>
        <div class="info-row">
            <div class="label">Expected Selling Date</div>
            <div class="sep">:</div>
            <div class="value">
                Start:
                {{
                    placement?.expectedStartSellingDate ||
                        expectedStartSellingDate | date: 'yyyy-MM-dd'
                }}
                End:
                {{
                    placement?.expectedEndSellingDate || expectedEndSellingDate
                        | date: 'yyyy-MM-dd'
                }}
            </div>
        </div>
    </div>
</div>
